<div class="account-flyout">
  <a
    fxFlex
    class="account-flyout__nologin"
    (click)="navigateToIdam($event)"
    (keydown.enter)="navigateToIdam($event)"
    (keydown.space)="navigateToIdam($event)"
    [mmTestTarget]="'login-link-desktop'"
    rel="nofollow"
    tabindex="0"
    href="#"
    [attr.aria-label]="
      ('CORE.ALL_PAGES.USER_BOX.SIGNUP.LABEL' | translate) + '/' + ('CORE.ALL_PAGES.USER_BOX.LOGIN.LABEL' | translate)
    "
  >
    <img aria-hidden="true" loading="lazy" [src]="avatarIcon" class="account-flyout__avatar" width="24" height="24" alt="User avatar" />
    <span>
      {{ 'CORE.ALL_PAGES.USER_BOX.SIGNUP.LABEL' | translate }}/{{ 'CORE.ALL_PAGES.USER_BOX.LOGIN.LABEL' | translate }}
    </span>
  </a>
</div>
